// extracted by mini-css-extract-plugin
module.exports = {"with-no-gutters":"SpendDistribution_with-no-gutters__2l_zk","with-padding":"SpendDistribution_with-padding__puswA"};